import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import {Formik} from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";

export default class User extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            userId: null,
            userData: null,
            notFound: false,
            cohorts: [],
            events: [],
            offers: []
        };
        this.getUser = this.getUser.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        if (id) {
            console.log(`Fetching user with id: ${id}`);
            this.getUser({ id });
        }
    }

    saveUser(request)  {
        console.trace("saveUser");
        let userId = this.state.userId;
        fetcher(`${config.API()}users/${userId}/save`, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(request)
        })
            .then(response => response.json())
            .then(() => {
                this.getUser({id: userId});
            });
    }

    async getUser(values)  {
        try {
            const [responseCohorts, responseEvents, responseOffers, responseUser] = await Promise.all([
                fetcher(`${config.API()}collection/cohorts`),
                fetcher(`${config.API()}collection/events`),
                fetcher(`${config.API()}collection/offer-lines`),
                fetcher(`${config.API()}users/${encodeURIComponent(values.id)}`)
            ]);

            this.cohorts = await responseCohorts.json();
            this.eventSettings = await responseEvents.json();
            this.offerSettings = await responseOffers.json();

            const data = await responseUser.json();
            if (!data.user) {
                this.setState({
                    cohorts: [],
                    events: [],
                    offers: [],
                    userId: -1,
                    userData: null,
                    notFound: true
                });
                return;
            }

            if (!data.user.hasOwnProperty("stars")) {
                data.user.stars = 0;
            }

            this.setState({
                cohorts: data.cohorts || [],
                events: data.events || [],
                offers: data.offers || [],
                userId: data.user ? data.user._id : -1,
                userData: data.user,
                notFound: false
            });
        } catch (err) {
            console.error(err);
        }
    }

    removeUser()  {
        let isOk = window.confirm("Are you sure?");
        const userId = this.state.userId;
        console.log(userId);
        if (isOk) {
            fetcher(`${config.API()}users/${userId}/remove`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                cache: "no-cache"
            })
                .then(response => response.json())
                .then(() => {
                    this.props.history.push("/users")
                }).catch(function (err) {
                console.error(err);
            });
        }
    }

    formatDate(value) {
        if (!value) {
            return "";
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime()) || date.getFullYear() <= 1) {
            return "";
        }

        return date.toLocaleString();
    }

    getEventStateLabel(state) {
        switch (state) {
            case 1:
                return "Active";
            case 2:
                return "Processing";
            case 3:
                return "End";
            case 4:
                return "Finish";
            default:
                return `Unknown (${state})`;
        }
    }

    renderUserEventCard(event) {
        const eventSetting = _.find(this.eventSettings, setting => setting._id == event.eventId);
        const title = eventSetting ? eventSetting.title : event.eventId;
        const createdAt = this.formatDate(event.createdAt);
        const finishedAt = this.formatDate(event.fd || event.finished);
        const state = event.st !== undefined ? event.st : event.state;
        const score = event.s !== undefined ? event.s : event.score;
        const position = event.p !== undefined ? event.p : event.position;

        return <div
            className="alert-info p-3 l mr-3 mb-3 d-inline-block align-top"
            style={{ minWidth: 320, maxWidth: 420 }}
            key={`event-${event._id}`}
        >
            <div className="font-weight-bold">
                <Link to={`/events/${event.eventId}`}>{title}</Link>
            </div>
            <div className="small text-muted">doc: {event._id}</div>
            <div className="small">state: {this.getEventStateLabel(state)}</div>
            <div className="small">sequenceId: {event.sequenceId}</div>
            <div className="small">groupId: {event.groupId || "-"}</div>
            {createdAt && <div className="small">createdAt: {createdAt}</div>}
            {event.lbId && <div className="small">leaderboardId: {event.lbId}</div>}
            {(score !== undefined && score !== null) && <div className="small">score: {score}</div>}
            {(position !== undefined && position !== null) && <div className="small">position: {position}</div>}
            {finishedAt && <div className="small">finishedAt: {finishedAt}</div>}
            <JsonEditorComponent className="btn btn-icon btn-light btn-sm mt-2" data={event} saveHandler={() => {}}/>
        </div>;
    }

    renderUserOfferCard(offer) {
        const offerSetting = _.find(this.offerSettings, setting => setting._id == offer.eventId);
        const title = offerSetting ? offerSetting.title : offer.eventId;
        const createdAt = this.formatDate(offer.createdAt);
        const version = offer.v !== undefined ? offer.v : offer.version;
        const productIds = offer.productIds || [];

        return <div
            className="alert-info p-3 l mr-3 mb-3 d-inline-block align-top"
            style={{ minWidth: 320, maxWidth: 420 }}
            key={`offer-${offer._id}`}
        >
            <div className="font-weight-bold">
                <Link to={`/offer-lines/${offer.eventId}`}>{title}</Link>
            </div>
            <div className="small text-muted">doc: {offer._id}</div>
            <div className="small">version: {version}</div>
            <div className="small">subOfferIndex: {offer.subOfferIndex}</div>
            <div className="small">groupId: {offer.groupId || "-"}</div>
            {createdAt && <div className="small">createdAt: {createdAt}</div>}
            {productIds.length > 0 && <div className="small">productIds: {productIds.join(", ")}</div>}
            <JsonEditorComponent className="btn btn-icon btn-light btn-sm mt-2" data={offer} saveHandler={() => {}}/>
        </div>;
    }

    render() {
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h2 className="m-0 font-weight-bold"> User {this.state.userData && this.state.userData.name} </h2></div>
                    <div className="card-body">
                        {this.state.notFound && <div className="alert alert-warning">User not found</div>}
                        {this.state.userData && <Formik enableReinitialize initialValues={this.state.userData} onSubmit={this.saveUser}>
                            {({
                                  values,
                                  handleSubmit,
                                  handleChange,
                                  setFieldValue,
                                  myHandleChange = evt => {
                                      if(evt.target.type == "number" && evt.target.value == "")
                                          evt.target.value = 0;
                                      handleChange(evt);
                                  }
                              }) => (
                                <div className="card shadow w100">
                                    <div className="card-header py-3">
                                        <h2 className="m-0 font-weight-bold l">Attributes <span className="text-primary">{values.name}</span></h2>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {values._id != "new" && <div className="form-group row">
                                                <label className="col-sm-2 col-form-label">Id</label>
                                                <div className="col-sm-10">
                                                    {values._id}
                                                    <input className="form-control" type="hidden" name="_id" onChange={myHandleChange} value={values._id}/>
                                                </div>
                                            </div>}
                                            <div className="form-group row">
                                                <div htmlFor={`qa`} className="col-2 col-form-label">QA</div>
                                                <div className="col-10">
                                                    <input id={`qa`} type="checkbox" name={`qa`} value={values.qa} checked={values.qa} className="form-check-input ml-3 mt-2 scale2" onChange={myHandleChange} />
                                                </div>
                                            </div>
                                            {Object.keys(values).map(k => {
                                                if (typeof values[k] == "object") {
                                                    return <div className=" form-group row" key={`prop${k}`}>
                                                        <div className="col-2 col-form-label">{k}</div>
                                                        <div className="col-10">
                                                            <JsonEditorComponent className="btn btn-icon btn-light  ml-1" data={values[k]} saveHandler={(data) => setFieldValue(k, data)}/>
                                                        </div>
                                                    </div>
                                                } else if (k != "_id" &&  k != "qa") {
                                                    return <div className=" form-group row" key={`prop${k}`}>
                                                        <div className="col-2 col-form-label">{k}</div>
                                                        <div className="col-10">
                                                            <input className="form-control" type={typeof values[k] == "number" ? "number" : "text"} name={k}
                                                                   value={values[k] || ""} onChange={myHandleChange}/>
                                                        </div>
                                                    </div>
                                                }
                                                return null;
                                            })}

                                            <button type="submit" className="btn btn-icon btn-success ml-1 r"><span className="fas fa-fw fa-save"></span>Save</button>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </Formik>}
                        <div className="row">
                            <div className="col-12">
                                <button type="button" className="r btn btn-icon btn-danger ml-1" onClick={this.removeUser}><span className="fas fa-fw fa-remove"></span> Remove</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h4 className="m-0 font-weight-bold"> Cohorts <span className="fas fa-fw fa-info-circle text-primary" title="Корты к которым принадлежит этот игрок"></span></h4></div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                {this.cohorts && this.state.cohorts && this.state.cohorts.map((cohort) => {
                                    let cohortSetting = _.find(this.cohorts, m => m._id == cohort);
                                    return <div className="alert-info p-2 l mr-3 d-inline-block" key={`c${cohort}`}>
                                        <Link to={`/cohorts/${cohort}`}>{cohortSetting ? cohortSetting.title : cohort}</Link>
                                    </div>;
                                })}
                                {(!this.state.cohorts || this.state.cohorts.length === 0) && <div className="text-muted">No cohorts</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h4 className="m-0 font-weight-bold"> Events </h4></div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                {this.state.events && this.state.events.length > 0 && this.state.events.map(event => this.renderUserEventCard(event))}
                                {(!this.state.events || this.state.events.length === 0) && <div className="text-muted">No user events</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h4 className="m-0 font-weight-bold"> Offers </h4></div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                {this.state.offers && this.state.offers.length > 0 && this.state.offers.map(offer => this.renderUserOfferCard(offer))}
                                {(!this.state.offers || this.state.offers.length === 0) && <div className="text-muted">No user offers</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
